import { render } from "./LifeProtectionAnalysis.vue?vue&type=template&id=7a2935f9&scoped=true"
import script from "./LifeProtectionAnalysis.vue?vue&type=script&lang=js"
export * from "./LifeProtectionAnalysis.vue?vue&type=script&lang=js"

import "./LifeProtectionAnalysis.vue?vue&type=style&index=0&id=7a2935f9&lang=css"
import "./LifeProtectionAnalysis.vue?vue&type=style&index=1&id=7a2935f9&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2935f9"]])

export default __exports__